import { generateUtilityClass, generateUtilityClasses } from "@suid/base";
export function getToggleButtonGroupUtilityClass(slot) {
    return generateUtilityClass("MuiToggleButtonGroup", slot);
}
const toggleButtonGroupClasses = generateUtilityClasses("MuiToggleButtonGroup", [
    "root",
    "selected",
    "vertical",
    "disabled",
    "grouped",
    "groupedHorizontal",
    "groupedVertical",
]);
export default toggleButtonGroupClasses;
